import isFunction from 'lodash/isFunction';
import forEach from 'lodash/forEach';
import isArray from 'lodash/isArray';
import './simpleSelectBox.scss';

class SimpleSelectBoxCtrl {
    constructor($sce, imagesService, dataService, apiService, $scope, $rootScope) {
        if (angular.isUndefined(this.multiSelect)) {
            this.multiSelect = false;
        }

        if (angular.isUndefined(this.selectedOptions)) {
            this.selectedOptions = [];
        }
        this.moreInfo = null;
        this.sce = $sce;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.imagesService = imagesService;
        this.dataService = dataService;
        this.apiService = apiService;
        this.$rootScope.$on('colorChangeEvent', () => this.refreshOptions());
        this.$rootScope.$on('dimensionsChangeEvent', () => this.refreshOptions());
        this.$rootScope.$on('windowFunctionChangeEvent', () => this.getHandlesSides());
    }

    refreshOptions() {
        if (this.defaultSelectedIdFieldName === 'accessories') {
            this.selectedOptions = this.dataService.accesoryData || [];
        }
    }

    isSelected(id) {
        if (isArray(this.selectedOptions)) {
            return this.selectedOptions.indexOf(id) !== -1;
        }

        return this.selectedOptions == id; // eslint-disable-line eqeqeq
    }

    /**
     * Reset button functionality
     */
    reset() {
        this.selectedOptions = this.dataService.reset(
            this.defaultSelectedIdFieldName,
        );
    }

    getOptions() {
        return this.options;
    }

    onInit() {
        this.moreInfo = this.dataService.getMoreInfo(this.defaultSelectedIdFieldName);
        if (this.showIncludedAccessories) {
            this.includedAccessories = this.dataService.getSelectedOption('includedAccessories', 'includedAccessories');
        }
        this.trustHtml();
    }

    trustHtml() {
        forEach(this.options, (el) => {
            if (angular.isDefined(el.attributes.subtitle)) {
                this.sce.trustAsHtml(el.attributes.subtitle);
            }
        });
    }

    closeBox() {
        if (isFunction(this.closeBoxCallback)) {
            this.closeBoxCallback();
        }
        this.selectedOptions = [];
    }

    isPacketSelected() {
        return this.dataService.isPacketSelected();
    }

    isBlocked(option) {
        return option.blocked || (option.attributes.isDefault && ['7', '8'].indexOf(option.attributes.accessoryType) === -1) ||
            (this.defaultSelectedIdFieldName === 'accessories' && this.dataService.isSelectedInPacket(option.id));
    }

    toggleSelected(id) {
        if (this.defaultSelectedIdFieldName === 'accessories' && this.dataService.isSelectedInPacket(id)) {
            return;
        }

        if (this.multiSelect) {
            const hingeTypes = [7, 8];
            const defaultHingeType = this.dataService.data.included.accessory.find(el => el.attributes.accessoryType === 8);

            if (this.selectedOptions.indexOf(id) !== -1) {
                if (this.defaultSelectedIdFieldName === 'accessories') {
                    const selectedAccessory = this.dataService.getAttributeOption('accessory', id);

                    if (
                        hingeTypes.indexOf(selectedAccessory.attributes.accessoryType) !== -1 &&
                        angular.isDefined(defaultHingeType)
                    ) {
                        this.selectedOptions.push(defaultHingeType.id);
                    }
                }
                this.selectedOptions.splice(this.selectedOptions.indexOf(id), 1);
            } else {
                if (this.defaultSelectedIdFieldName === 'accessories') {
                    const selectedAccessory = this.dataService.getAttributeOption('accessory', id);
                    const selectedAccessories = this.dataService.getSelectedOption('accessories', 'accessory');

                    if (hingeTypes.indexOf(selectedAccessory.attributes.accessoryType) !== -1) {
                        selectedAccessories.forEach((accessory) => {
                            if ((
                                hingeTypes.indexOf(accessory.attributes.accessoryType) !== -1 &&
                                accessory.attributes.accessoryType !== selectedAccessory.attributes.accessoryType
                            ) || (
                                !selectedAccessory.attributes.allowMultiple &&
                                accessory.attributes.accessoryType === selectedAccessory.attributes.accessoryType
                            )) {
                                this.selectedOptions.splice(
                                    this.selectedOptions.indexOf(accessory.id),
                                    1
                                );
                            }
                        });
                    }
                }
                this.selectedOptions.push(id);
            }
        } else {
            this.selectedOptions = [id];
        }
        this.dataService.updateSelectedOptions(
            this.defaultSelectedIdFieldName,
            this.selectedOptions,
            this.options[0].type,
            false,
        );
        if (this.defaultSelectedIdFieldName === 'accessories' && this.showIncludedAccessories) {
            this.includedAccessories = this.dataService.getSelectedOption('includedAccessories', 'includedAccessories');
        }
        if (this.defaultSelectedIdFieldName !== 'glazing') {
            this.$rootScope.$emit('colorChangeEvent');
        }
    }

    getCaptionImage(type) {
        return this.imagesService.getCaptionImageUrl(this.defaultSelectedIdFieldName, type);
    }

    getImage(imgSrc) {
        return this.imagesService.getFullUrl(imgSrc);
    }

    setImage($event, imgSrc) {
        $($event.target).parent().find('.confSimpleSelect__content-item-icon-hover').attr('src', this.getImage(imgSrc));
    }

    openAccessoryModal(accessory) {
        if (isFunction(this.openModalCallback)) {
            this.openModalCallback({
                modalTitle: accessory.attributes.name,
                modalContent: accessory.attributes.modalContent,
            });
        }
    }

    isAvailable(option) {
        if (option.id === '7' && this.dataService.jsonService.blindsError) {
            return true;
        }
        return false;
    }

    openDescriptionModal(option) {
        this.openModalCallback({
            modalTitle: option.attributes.name,
            modalContent: option.attributes.description,
            modalImgSrc: option.attributes.imgSrc,
        });
    }

    openModal(option) {
        if (isFunction(this.openModalCallback)) {
            this.openModalCallback({
                modalTitle: option.attributes.modalTitle,
                modalContent: option.attributes.modalContent,
                modalImgSrc: option.attributes.modalImgSrc
            });
        }
    }

    openMoreInfoModal(moreInfo) {
        if (isFunction(this.openModalCallback)) {
            this.openModalCallback({
                modalTitle: moreInfo.attributes.name,
                modalContent: moreInfo.attributes.content,
            });
        }
    }
}

SimpleSelectBoxCtrl.$inject = ['$sce', 'imagesService', 'dataService', 'handlesService', 'apiService', '$scope', '$rootScope'];

export default SimpleSelectBoxCtrl;
